import { Dropdown } from '@festina-life/ui/structure'

import { useLayoutContext } from '../../context/layoutContext'
import { useAvailableConfigurationPersonas } from '../../hooks/useAvailableConfigurationPersonas'
import { PersonaBadge } from './PersonaBadge'
import { useConfigurationPersonaName } from './useConfigurationPersonaName'

export const ConfigurationPersonaSelector = () => {
  const { onChangePersona, persona } = useLayoutContext()
  const availablePersonas = useAvailableConfigurationPersonas()
  const personaOptions = useConfigurationPersonaName()

  if (availablePersonas.length === 0) {
    return null
  }

  const { name, description } = personaOptions[persona]

  return (
    <div className="flex gap-x-2 items-center">
      {availablePersonas.length > 1 ? (
        <Dropdown
          element={<PersonaBadge tip={description}>{name}</PersonaBadge>}
          items={availablePersonas.map((availablePersona) => ({
            element: personaOptions[availablePersona].name,
            onClick: () => onChangePersona(availablePersona),
          }))}
        />
      ) : (
        <PersonaBadge tip={description}>{name}</PersonaBadge>
      )}
    </div>
  )
}
